import { IconName } from '@optimus-web/icons';
import { ButtonLoaderIcon } from './style';
import { ButtonVariant } from './types';

export const ButtonLoader = ({ buttonVariant }: { buttonVariant: ButtonVariant }) => (
    <ButtonLoaderIcon variant="inherit" value={IconName.Spinner} size="small" buttonVariant={buttonVariant} />
);
